import { Card, CardContent } from '@g17eco/ui-modern/components/ui/card';

export interface SquareCardItem {
  id: string;
  title: string;
  description: string;
  icon: string;
  iconBgColor: string;
  iconColor: string;
  comingSoon?: boolean;
  onClick?: () => void;
}

interface SquareCardProps {
  item: SquareCardItem;
}

export const SquareCard = ({ item }: SquareCardProps) => {
  const disabled = item.comingSoon || !item.onClick;
  return (
    <Card
      className={`tw:border-0 tw:shadow-sm tw:relative tw:overflow-hidden tw:aspect-square ${item.comingSoon ? 'tw:bg-gray-100' : ''} ${disabled ? 'tw:cursor-not-allowed' : 'tw:cursor-pointer'}`}
      onClick={disabled ? undefined : item.onClick}
    >
      {item.comingSoon && (
        <div className='tw:absolute tw:top-2.5 tw:-right-7 tw:rotate-45 tw:bg-gray-500/85 tw:text-white tw:text-[0.55rem] tw:font-medium tw:py-0.5 tw:px-8 tw:tracking-wide tw:z-10'>
          SOON
        </div>
      )}
      <CardContent className='tw:p-4 tw:pt-5 tw:h-full tw:flex tw:flex-col tw:items-center tw:text-center'>
        <div
          className='tw:rounded-full tw:flex tw:items-center tw:justify-center tw:size-14 tw:shrink-0 tw:mb-3'
          style={{ backgroundColor: item.iconBgColor }}
        >
          <i className={`fa ${item.icon} fa-xl`} style={{ color: item.iconColor }} />
        </div>
        <h6 className='tw:font-semibold tw:mb-1 tw:leading-tight'>{item.title}</h6>
        <p className='text-ThemeTextLight tw:mb-0 tw:line-clamp-3 tw:text-xs tw:leading-snug'>
          {item.description}
        </p>
      </CardContent>
    </Card>
  );
};

interface SquareCardGridProps {
  items: SquareCardItem[];
  columns?: number;
}

export const SquareCardGrid = ({ items, columns = 5 }: SquareCardGridProps) => (
  <div
    className='tw:grid tw:gap-4'
    style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}
  >
    {items.map((item) => (
      <SquareCard key={item.id} item={item} />
    ))}
  </div>
);
